import type { RootState } from '@/store';

export const selectedIncidentSelector = (state: RootState) => state.incidents.selectedIncident;
export const userIncidentsSelector = (state: RootState) => state.incidents.userIncidents;
export const activeDeconIncidentSelector = (state: RootState) =>
  state.incidents.activeDeconIncident;
